<template>
  <div :class="`form-element form-${type}-element`" />
</template>

<script>
export default {
  props: {
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  }
};
</script>
